import { CAMPAIGNS } from '@/constants/campaigns'

type TCampaigns = typeof CAMPAIGNS
type TCampaign = TCampaigns[keyof TCampaigns] & { theme: Theme }

export const getCurrentCampaign = (...pathnames: string[]): TCampaign => {
  const pathSegments = pathnames.flatMap((pathname) =>
    pathname.split('/').filter(Boolean),
  )

  const currentCampaignSlug = pathSegments.find((segment) =>
    Object.values(CAMPAIGNS).some((campaign) => campaign.basePath === segment),
  )

  const currentCampaign = Object.values(CAMPAIGNS).find(
    (campaign) => campaign.basePath === currentCampaignSlug,
  )

  return currentCampaign ?? Object.create(null)
}
